module.exports = __webpack_public_path__ + "media/home/campaign-popup-5a504987.png";